import {
  Box, Typography, IconButton, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Chip
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useState, useEffect } from "react";
import Header from "../../components/Header";
import { getApiImagen } from "../../utils/getApiBaseUrl";
import { updateUniforme } from "../../services/uniformes.services";
import { getUniformes } from "../../services/uniformes.services";
import ModalSuccess from "../../modal/modalSucces";
import ModalDeleteSuccess from "../../modal/modalDeleteSucces";

const AMBER = "#ffa726";
const RED_DARK = "#dd4048";

const btnBase = {
  display: "flex", alignItems: "center", gap: 0.8,
  px: 2.5, py: 1.1, borderRadius: "10px", fontSize: 14,
  fontWeight: 500, cursor: "pointer", border: "none",
  transition: "all .15s",
};

const Uniformes = () => {
  const [rows, setRows] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [deletingRow, setDeletingRow] = useState(null);
  const [cantMin, setCantMin] = useState("");
  const [cantMinError, setCantMinError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  useEffect(() => {
  const fetchData = async () => {
    try {
      const data = await getUniformes();
      setRows(data);
    } catch (error) {
      console.error("ERROR GET:", error);
    }
  };

  fetchData();
}, []);

const handleGuardar = async () => {
  if (!cantMin.toString().trim()) {
    setCantMinError("Por favor, ingrese un número.");
    return;
  }

  const num = Number(cantMin);

  if (isNaN(num) || num <= 0) {
    setCantMinError("El stock debe ser un número mayor a 0.");
    return;
  }

  try {
    // Enviamos el objeto correcto al backend
    await updateUniforme(editingRow.id, { cant_min: num });
    
    // Actualizamos el estado local de la tabla
    setRows((prev) =>
      prev.map((r) => r.id === editingRow.id ? { ...r, cant_min: num } : r)
    );
    
    // 1. Limpiamos errores si los hubiera
    setCantMinError("");
    // 2. Cerramos el modal de edición
    setEditingRow(null);
    // 3. ¡Disparamos tu modal de éxito!
    setShowSuccessModal(true);

  } catch (err) {
    console.error("Error al actualizar cant_min:", err);
    setCantMinError("Ocurrió un error en el servidor al guardar.");
  }
};

const handleEliminar = async () => {
  try {

    await updateUniforme(deletingRow.id, { status_active: 0 });
    

    setRows((prev) => prev.filter((r) => r.id !== deletingRow.id));
    

    setDeletingRow(null);
    setShowDeleteModal(true);
    
  } catch (err) {
    console.error("Error al eliminar uniforme (borrado lógico):", err);
    
  }
};

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      renderCell: (params) => (
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          #{params.value}
        </Typography>
      ),
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      flex: 0.7,
      renderCell: (params) => (
        <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "talla",
      headerName: "Talla",
      width: 90,
    },
    {
      field: "cant_min",
      headerName: "Stock mínimo",
      width: 150,
      renderCell: (params) => (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            background: "rgba(255,167,38,0.08)",
            border: "1px solid rgba(255,167,38,0.25)",
            borderRadius: "20px",
            px: 1.5,
            py: 0.3,
          }}
        >
          <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: AMBER }} />
          <Typography sx={{ fontSize: "18px", fontWeight: 700, color: AMBER }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "img",
      headerName: "Imagen",
      flex: 0.6,
      minWidth: 100,
      renderCell: (params) => (
        <img
          src={`${getApiImagen()}${params.value}`}
          alt="Uniforme"
          style={{ width: "150px", height: "100px", objectFit: "cover", borderRadius: "10px" }}
        />
      ),
    },
    {
  field: "acciones",
  headerName: "Acciones",
  width: 140, // Incrementamos un poco el ancho de la columna para que entren cómodos los botones más grandes
  sortable: false,
  renderCell: (params) => (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", height: "100%" }}>
      <IconButton
        size="medium" // Botón más grande
        onClick={() => {
          setEditingRow(params.row);
          setCantMin(params.row.cant_min ?? "");
          setCantMinError("");
        }}
        sx={{ 
          color: AMBER, 
          padding: "8px", // Más área de click
          "&:hover": { bgcolor: "#fff8ee" } 
        }}
      >
        <EditIcon sx={{ fontSize: "28px" }} /> {/* Icono más grande */}
      </IconButton>
      
      <IconButton
        size="medium" // Botón más grande
        onClick={() => setDeletingRow(params.row)}
        sx={{ 
          color: RED_DARK, 
          padding: "8px", // Más área de click
          "&:hover": { bgcolor: "#fdf0f0" } 
        }}
      >
        <DeleteIcon sx={{ fontSize: "28px" }} /> {/* Icono más grande */}
      </IconButton>
    </Box>
  ),
},
  ];

  return (
    <Box m="20px">
      <Header title="Uniformes" subtitle="Lista de uniformes" />
      <DataGrid
  autoHeight
  rows={rows}
  columns={columns}
  getRowId={(r) => r.id}
/>

      {/* ── Modal editar ── */}
      <Dialog
        open={!!editingRow}
        onClose={() => setEditingRow(null)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden", bgcolor: "#021b74ea", color: "#fff", } }}
      >
        <DialogTitle
          sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1.5,
            borderBottom: "0.5px solid", borderColor: "divider" }}
        >
          <Box sx={{ width: 40, height: 40, borderRadius: "10px", bgcolor: "#fff8ee",
            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <EditIcon sx={{ color: AMBER, fontSize: 26 }} />
          </Box>
          <Box>
            <Typography fontWeight={500} fontSize={18}>Editar stock mínimo</Typography>
            <Typography fontSize={14} color="text.secondary">Uniforme seleccionado</Typography>
          </Box>
          <IconButton size="small" onClick={() => setEditingRow(null)} sx={{ ml: "auto" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 2.5, pb: 1 }}>
          {editingRow?.img && (
  <Box
    sx={{
      width: "100%",
      height: 180, // Subimos el alto para que luzca mejor en el modal
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "rgba(255, 255, 255, 0.05)", // Fondo sutil que combina con tu fondo oscuro
      borderRadius: "12px",
      mb: 2.5,
      p: 1, // Espaciado interno para que no toque los bordes
      border: "1px solid",
      borderColor: "rgba(255, 255, 255, 0.1)",
      overflow: "hidden"
    }}
  >
    <Box
      component="img"
      src={`${getApiImagen()}${editingRow.img}`}
      alt="Uniforme"
      sx={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain", // <- Clave: Muestra la prenda completa sin deformar ni cortar
        borderRadius: "8px",
      }}
    />
  </Box>
)}

          <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
            <Box flex={1}>
              <Typography fontSize={11} fontWeight={500} color="text.secondary"
                textTransform="uppercase" letterSpacing={0.3} mb={0.5}>
                Descripción
              </Typography>
              <Box sx={{ bgcolor: "action.hover", borderRadius: "8px", px: 1.5, py: 1,
                border: "0.5px solid", borderColor: "divider", fontSize: 14 }}>
                {editingRow?.descripcion}
              </Box>
            </Box>
            <Box minWidth={64}>
              <Typography fontSize={11} fontWeight={500} color="text.secondary"
                textTransform="uppercase" letterSpacing={0.3} mb={0.5}>
                Talla
              </Typography>
              <Box sx={{ bgcolor: "action.hover", borderRadius: "8px", px: 1.5, py: 1,
                border: "0.5px solid", borderColor: "divider", fontSize: 14 }}>
                {editingRow?.talla}
              </Box>
            </Box>
          </Box>

          <Typography fontSize={11} fontWeight={500} color="text.secondary"
            textTransform="uppercase" letterSpacing={0.3} mb={0.5}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            Stock mínimo
            <Chip
              label={`Actual: ${editingRow?.cant_min}`}
              size="small"
              sx={{ fontSize: 11, height: 20, bgcolor: "#fff8ee", color: "#7a4500",
                border: "0.5px solid rgba(255,167,38,.35)", "& .MuiChip-label": { px: 1 } }}
            />
          </Typography>
          <TextField
  fullWidth
  type="number"
  value={cantMin}
  onChange={(e) => {
    setCantMin(e.target.value);
    if (cantMinError) setCantMinError(""); // Quita el rojo mientras el usuario escribe
  }}
  inputProps={{ min: 1 }}
  
  // ─── Atributos de Error ───
  error={Boolean(cantMinError)} 
  helperText={cantMinError}
  
  sx={{ 
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px", 
      fontSize: 14,
      // Color ámbar cuando está enfocado y NO tiene error
      "&.Mui-focused fieldset": { 
        borderColor: cantMinError ? "error.main" : AMBER, 
        borderWidth: 1.5 
      },
      "&:hover fieldset": { 
        borderColor: cantMinError ? "error.main" : AMBER 
      },
    },
    // Estilo opcional para que el texto de error combine bien con tu fondo oscuro
    "& .MuiFormHelperText-root": {
      fontSize: "12px",
      marginTop: "4px"
    }
  }}
/>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2.5, pt: 1.5, gap: 1,
          borderTop: "0.5px solid", borderColor: "divider" }}>
          <Box component="button" onClick={() => setEditingRow(null)}
            sx={{ ...btnBase, bgcolor: "transparent", color: RED_DARK,
              border: `1.5px solid ${RED_DARK}`,
              "&:hover": { bgcolor: RED_DARK, color: "#fff" } }}>
            <CloseIcon sx={{ fontSize: 16 }} /> Cancelar
          </Box>
          <Box component="button" onClick={handleGuardar}
            sx={{ ...btnBase, bgcolor: AMBER, color: "#fff",
              "&:hover": { bgcolor: "#e65100" } }}>
            <SaveIcon sx={{ fontSize: 16 }} /> Guardar cambios
          </Box>
        </DialogActions>
      </Dialog>

      {/* ── Modal eliminar ── */}
      <Dialog
        open={!!deletingRow}
        onClose={() => setDeletingRow(null)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}
      >
        <DialogTitle
          sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1.5,
            borderBottom: "0.5px solid", borderColor: "divider" }}
        >
          <Box sx={{ width: 40, height: 40, borderRadius: "10px", bgcolor: "#fdf0f0",
            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <DeleteIcon sx={{ color: RED_DARK, fontSize: 28 }} />
          </Box>
          <Box>
            <Typography fontWeight={500} fontSize={18}>Eliminar uniforme</Typography>
            <Typography fontSize={15} color="text.secondary">
              Esta acción no se puede deshacer
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setDeletingRow(null)} sx={{ ml: "auto" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 2.5, pb: 1 }}>
          <Box sx={{ bgcolor: "#fdf0f0", border: "0.5px solid rgba(84,27,30,.2)",
            borderRadius: "10px", p: 1.8, display: "flex", gap: 1.5, alignItems: "flex-start" }}>
            <WarningAmberIcon sx={{ color: RED_DARK, fontSize: 22, flexShrink: 0, mt: 0.2 }} />
            <Typography fontSize={14} color={RED_DARK} lineHeight={1.6}>
              ¿Estás seguro de que deseas eliminar el uniforme{" "}
              <strong>{deletingRow?.descripcion} (Talla {deletingRow?.talla})</strong>?
              Este registro se eliminará permanentemente.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2.5, pt: 1.5, gap: 1,
          borderTop: "0.5px solid", borderColor: "divider" }}>
          <Box component="button" onClick={() => setDeletingRow(null)}
            sx={{ ...btnBase, bgcolor: "transparent", color: RED_DARK,
              border: `1.5px solid ${RED_DARK}`,
              "&:hover": { bgcolor: RED_DARK, color: "#fff" } }}>
            <CloseIcon sx={{ fontSize: 16 }} /> Cancelar
          </Box>
          <Box component="button" onClick={handleEliminar}
            sx={{ ...btnBase, bgcolor: RED_DARK, color: "#fff",
              "&:hover": { bgcolor: "#7a2226" } }}>
            <DeleteIcon sx={{ fontSize: 18 }} /> Sí, eliminar
          </Box>
        </DialogActions>
      </Dialog>
      <ModalSuccess 
        open={showSuccessModal} 
        onClose={() => setShowSuccessModal(false)} 
      />
      <ModalDeleteSuccess 
        open={showDeleteModal} 
        onClose={() => setShowDeleteModal(false)} 
      />
    </Box>
  );
};

export default Uniformes;